import Api from '@/services/Api'

export default {
  index(query) {
    return Api().get('teya', {
      params: query    
    })
  },
  initiate(data) {
    return Api().post('/teya/initiate', data)
  },
  webhooks(data) {
    return Api().post('/teya/webhooks', data)
  },
  status(query) {
    return Api().get('/teya/status', {
      params: query
    })
  }
}